import React, { useState } from 'react';
import axios from 'axios';
import Success from '../../../equipmentSurveys/components/Success';
import Submit from '../../../equipmentSurveys/components/Submit';
import BasicInfoUnitForm from '../../components/BasicInfoUnitForm';
import AdditionalBasicInfoFields from './AdditionalBasicInfoFields';
import NaturalDisasterQuestion from '../../components/NaturalDisasterQuestion';
import RenderError from '../../components/RenderError';

function BasicInfo({
  applicationData: {
    aid,
    unitOne = {},
    unitOneReceipt,
    unitTwo,
    unitTwoReceipt,
    naturalDisaster,
    disasterZipcode,
    equipment_counts: { PowerGenerator }
  } = {},
  setApplicationData,
  initialView,
  setView
}) {
  const [numberOfUnits, setNumberOfUnits] = useState(
    unitTwo !== undefined && Object.keys(unitTwo).length > 0 ? 2 : 1
  );
  const [numberOfUnitsError, setNumberOfUnitsError] = useState('');

  let initialState = {
    aid: aid ?? '',
    unitOne: {
      purchaseDate: unitOne.purchaseDate ?? '',
      purchaseAmount: unitOne.purchaseAmount ?? 0,
      manufacturer: unitOne.manufacturer ?? '',
      model: unitOne.model ?? '',
      serialNumber: unitOne.serialNumber ?? '',
      receipt: unitOneReceipt ?? '',
      equipmentDealer: unitOne.equipmentDealer ?? '',
      state: unitOne.state ?? '',
      generatorType1: unitOne.generatorType ?? '',
      generatorSize: unitOne.generatorSize ?? 0,
      typeOfSite1: unitOne.typeOfSite ?? '',
      monthsPerYear: unitOne.monthsPerYear ?? 0,
      hoursPerDay: unitOne.hoursPerDay ?? 0,
      totalPower: unitOne.totalPower ?? 0,
      connectedToGrid1: unitOne.connectedToGrid ?? ''
    },
    naturalDisaster: naturalDisaster ?? '0',
    zipcode: disasterZipcode ?? ''
  };

  if (unitTwo !== undefined) {
    initialState = {
      ...initialState,
      unitTwo: {
        purchaseDate: unitTwo.purchaseDate ?? '',
        purchaseAmount: unitTwo.purchaseAmount ?? 0,
        manufacturer: unitTwo.manufacturer ?? '',
        model: unitTwo.model ?? '',
        serialNumber: unitTwo.serialNumber ?? '',
        receipt: unitTwoReceipt ?? '',
        equipmentDealer: unitTwo.equipmentDealer ?? '',
        state: unitTwo.state ?? '',
        generatorType2: unitTwo.generatorType ?? [],
        generatorSize: unitTwo.generatorSize ?? 0,
        typeOfSite2: unitOne.typeOfSite ?? '',
        monthsPerYear: unitTwo.monthsPerYear ?? 0,
        hoursPerDay: unitTwo.hoursPerDay ?? 0,
        totalPower: unitTwo.totalPower ?? 0,
        connectedToGrid2: unitTwo.connectedToGrid ?? ''
      }
    };
  }

  const [formData, setFormData] = useState(initialState);
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');

  const handleUnitsSelect = (event) => {
    setNumberOfUnitsError('');
    const { value } = event.target;
    setNumberOfUnits(value);

    if (value > 1) {
      if (PowerGenerator === 2) {
        setNumberOfUnitsError(
          'You have reached the maximum of 2 power generator applications per year.'
        );
      } else {
        setFormData({
          ...formData,
          unitTwo: {
            purchaseDate: unitTwo !== undefined ? unitTwo.purchaseDate : '',
            purchaseAmount: unitTwo !== undefined ? unitTwo.purchaseAmount : 0,
            manufacturer: unitTwo !== undefined ? unitTwo.manufacturer : '',
            model: unitTwo !== undefined ? unitTwo.model : '',
            serialNumber: unitTwo !== undefined ? unitTwo.serialNumber : '',
            receipt: unitTwo !== undefined ? unitTwoReceipt : '',
            equipmentDealer:
              unitTwo !== undefined ? unitTwo.equipmentDealer : '',
            generatorType2: unitTwo !== undefined ? unitTwo.generatorType2 : '',
            generatorSize: unitTwo !== undefined ? unitTwo.generatorSize : 0,
            typeOfSite2: unitTwo !== undefined ? unitTwo.typeOfSite2 : '',
            monthsPerYear: unitTwo !== undefined ? unitTwo.monthsPerYear : 0,
            hoursPerDay: unitTwo !== undefined ? unitTwo.hoursPerDay : 0,
            totalPower: unitTwo !== undefined ? unitTwo.totalPower : 0,
            connectedToGrid2:
              unitTwo !== undefined ? unitTwo.connectedToGrid : ''
          }
        });
      }
    } else {
      let newFormData = formData;
      delete formData.unitTwo;
      setFormData(newFormData);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    setSuccess('');
    let data = new FormData();
    data.append('aid', formData.aid);
    Object.keys(formData.unitOne).forEach((key) => {
      data.append(`unit1${key}`, formData.unitOne[key]);
    });
    if ('unitTwo' in formData) {
      Object.keys(formData.unitTwo).forEach((key) => {
        data.append(`unit2${key}`, formData.unitTwo[key]);
      });
    }
    data.append('naturalDisaster', formData.naturalDisaster);
    if ('zipcode' in formData) {
      data.append('zipcode', formData.zipcode);
    }

    axios
      .post(
        window.wlPipConfig.ajaxUrl +
          '?action=wl_fip_save_power_generator_basic_info',
        data
      )
      .then((res) => {
        setLoading(false);
        setErrors([]);
        setSuccess(res.data.message);
        setApplicationData(res.data.applicationData);
        setTimeout(() => setView(initialView), 1000);
      })
      .catch((err) => {
        setLoading(false);
        setErrors(err.response.data.data);
      });
  };

  return (
    <div className="fip-equipment-survey grid u--padding-right-20">
      <div className="grid__col-xs-12">
        <div className="form__field form__field--required">
          <label className="form__label">
            How many units do you have for this application?
          </label>
          <div className="form__select form__select--lg">
            <select onChange={handleUnitsSelect} defaultValue={numberOfUnits}>
              <option value="1">One</option>
              {(aid || PowerGenerator < 1) && <option value="2">Two</option>}
            </select>
            <RenderError error={numberOfUnitsError} />
          </div>
        </div>
        <BasicInfoUnitForm
          equipmentType={'power_generator'}
          formData={formData}
          setFormData={setFormData}
          errors={errors}
        >
          <AdditionalBasicInfoFields />
        </BasicInfoUnitForm>
        {numberOfUnits > 1 && !numberOfUnitsError && (
          <BasicInfoUnitForm
            two={true}
            equipmentType={'power_generator'}
            formData={formData}
            setFormData={setFormData}
            errors={errors}
          >
            <AdditionalBasicInfoFields />
          </BasicInfoUnitForm>
        )}
        <NaturalDisasterQuestion
          formData={formData}
          setFormData={setFormData}
          errors={errors}
        />
        <Submit
          loading={loading}
          handleSubmit={handleSubmit}
          text="Save Section"
          errors={errors}
          success={success}
        />
        {success && <Success success={success} />}
      </div>
    </div>
  );
}

BasicInfo.displayName = 'BasicInfo'; // because WebPack renames the function
export default BasicInfo;
